import {
  useForm as useReactHookForm,
  type UseFormProps,
  type FieldValues,
} from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { type z } from "zod/v3";

type CompatibleZodSchema<T> = z.ZodType<T> & { _def: { typeName: string } };

export const useForm = <T extends FieldValues>(
  schema: z.ZodType<T>,
  options?: Omit<UseFormProps<T>, "resolver">,
) => {
  return useReactHookForm<T>({
    resolver: zodResolver(schema as CompatibleZodSchema<T>),
    ...options,
  });
};
